<template>
  <div class="fg-error" role="alert">
    <Icon name="alert" :size="16" class="fg-error__icon" />
    <div class="fg-error__content">
      <div class="fg-error__code">{{ error.code }}</div>
      <div class="fg-error__message">{{ error.message }}</div>
    </div>
    <button
      v-if="dismissable"
      class="fg-error__close"
      :aria-label="t('common.close')"
      @click="$emit('dismiss')"
    ><Icon name="x" :size="14" /></button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '../../i18n'
import Icon from '../Icon.vue'

withDefaults(
  defineProps<{ error: { code: string; message: string }; dismissable?: boolean }>(),
  { dismissable: true },
)
defineEmits<{ dismiss: [] }>()

const { t } = useI18n()
</script>
